import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

const roadmapStages = [
  {
    stage: 1,
    title: 'Request a Free Quote',
    items: [
      'Begin by telling us about your desired project, whether it’s about logo or web design. We’ll review your needs and send a custom, no-obligation quote.',
    ]
  },
  {
    stage: 2,
    title: 'Share Your Vision',
    items: [
      'Once you approve the quote, we’ll collect details like your brand style, color preferences, and inspiration. You can also share references.',
    ]
  },
  {
    stage: 3,
    title: 'First Concepts Delivered',
    items: [
      'We’ll kickstart the project. You’ll be subjected to receiving initial design concepts within a mutual deadline.',
    ]
  },
  {
    stage: 4,
    title: 'Revisions & Feedback',
    items: [
      'We refine your favorite design(s) based on your feedback. You’ll get multiple rounds of revisions to make sure it’s exactly what you want.',
    ]
  },
  {
    stage: 5,
    title: 'Final Delivery',
    items: [
      'Once you are happy with the design, we’ll deliver the final files — ready for web, print, or launch.',
    ]
  },
];

const RoadmapSection = () => {
  return (
    <section id="id_meme_roadmap_section" className="meme_roadmap_section section_space">
      <div className="container">
        <div className="memecoin_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
          <h2 className="heading_text text-uppercase mb-0">Our Roadmap</h2>
        </div>

        <div className="meme_roadmap_carousel">
          <Swiper
            loop={true}
            spaceBetween={30}
            grabCursor={false}
            breakpoints={{
              0: { slidesPerView: 1 },
              991: { slidesPerView: 2 },
              1025: { slidesPerView: 3 },
            }}
          >
            {roadmapStages.map((stage, index) => (
              <SwiperSlide key={index}>
                <div className="meme_roadmap_block">
                  <div className="serial_number text-uppercase">Stage: {stage.stage}</div>
                  <div className="roadmap_info">
                    <h3 className="roadmap_title text-uppercase">{stage.title}</h3>
                    <ul className="iconlist_block unordered_list_block">
                      {stage.items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          <span className="iconlist_icon">
                            <i className="fa-regular fa-square-check"></i>
                          </span>
                          <span className="iconlist_label">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
